export enum AdminProjectTemplateApiErrorTypes {
  AdminProjectTemplateLoadListError,
  AdminProjectTemplateCreateTemplateError,
  AdminProjectTemplateUpdateTemplateError,
  AdminProjectTemplateDeleteTemplateError,
  AdminProjectTemplateLoadTemplateError,
}

export class AdminProjectTemplateApiError {
  constructor(public type: AdminProjectTemplateApiErrorTypes, public error: Error) {}
}
